import { useQuery } from 'react-query';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IStudio } from '~/Models/DTO/Studio.model';

export const useRequestProvidersSearch = (query?: any) => {
  const result = useQuery<{ data: IStudio[]; responseHeaders: Headers | null }, IErrorResponse>(
    [query],
    async () => {
      let responseHeaders: Headers | null = null;
      const data = await requestReactQuery<IStudio[]>({
        url: PROVIDER_SERVICE_URLS.PROVIDER_LIST_SEARCH,
        config: { method: 'GET' },
        params: { ...query },
        retrieveResponseHeader: (headers) => (responseHeaders = headers),
      });
      return { data, responseHeaders };
    },
  );

  return { ...result, data: result?.data?.data, responseHeaders: result?.data?.responseHeaders };
};
